import React from "react";
import { Building2, MapPinned, Palette, Landmark, LogOut, Settings, Users } from "lucide-react";

const FONT = "'Plus Jakarta Sans', sans-serif";
// Nav atas sengaja ramping; konten (Radio/Koran/Info/Pesan) ada di Dashboard, Walikota di Pengaturan
const NAV = [["dashboard", "Dashboard", Landmark], ["warga", "Warga", Users], ["editor", "Editor Kota", MapPinned], ["studio", "Studio AI", Palette], ["office", "Office", Building2]];

// Header ala Gotrips: logo kiri, kapsul nav melayang di tengah, tombol lingkaran kanan
export function AdminHeader({ tab, unread, onTab, onDashboardAgain, onLogout }) {
  const onSettings = tab === "settings";
  return (
    <header style={{ display: "flex", alignItems: "center", gap: 8, margin: "16px 20px 0" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <span style={{ width: 34, height: 34, borderRadius: 12, background: "#0000CD", display: "grid", placeItems: "center" }}>
          <Building2 size={17} color="#fff" />
        </span>
        <b style={{ fontSize: 17, fontStyle: "italic", letterSpacing: -0.5, color: "#141414" }}>JAWSEL</b>
      </div>
      <div style={{ flex: 1, display: "flex", justifyContent: "center" }}>
        <nav style={{ display: "inline-flex", alignItems: "center", gap: 4, background: "#fff", borderRadius: 99, padding: "6px 8px", boxShadow: "0 8px 24px rgba(20,20,20,0.08)" }}>
          {NAV.map(([key, label, Icon]) => (
            <button key={key} data-testid={`tab-${key}`}
              onClick={() => { if (key === "dashboard" && tab === "dashboard") onDashboardAgain(); onTab(key); }}
              style={{
                position: "relative", display: "inline-flex", alignItems: "center", gap: 7, padding: "9px 16px", borderRadius: 99, border: 0,
                background: tab === key ? "#141414" : "transparent", color: tab === key ? "#fff" : "#141414",
                fontSize: 13, fontWeight: 600, fontFamily: FONT, transition: "background-color 0.15s"
              }}>
              <Icon size={15} color={tab === key ? "#4d4dff" : "#141414"} /> {label}
              {key === "dashboard" && unread > 0 && (
                <span data-testid="nav-unread-dot" title={`${unread} pesan warga belum dibaca`}
                  style={{ position: "absolute", top: 6, right: 8, minWidth: 16, height: 16, padding: "0 4px", borderRadius: 99, background: "#dc2626", color: "#fff", fontSize: 10, fontWeight: 800, display: "grid", placeItems: "center", border: "2px solid #fff", boxSizing: "border-box", lineHeight: 1 }}>
                  {unread > 9 ? "9+" : unread}
                </span>
              )}
            </button>
          ))}
        </nav>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <button data-testid="tab-settings" onClick={() => onTab("settings")} title="Pengaturan" aria-pressed={onSettings}
          style={{
            width: 36, height: 36, borderRadius: "50%", display: "grid", placeItems: "center", cursor: "pointer",
            border: `1.5px solid ${onSettings ? "#141414" : "#d8d4c4"}`, background: onSettings ? "#141414" : "transparent", color: onSettings ? "#fff" : "#141414",
            transition: "background-color 0.15s, color 0.15s",
          }}>
          <Settings size={15} />
        </button>
        <span data-testid="admin-avatar" style={{ width: 36, height: 36, borderRadius: "50%", border: "1.5px solid #d8d4c4", display: "grid", placeItems: "center", color: "#141414", background: "#e8e6da", fontSize: 13, fontWeight: 700 }}>A</span>
        <button data-testid="admin-logout-btn" onClick={onLogout} title="Keluar"
          style={{ width: 36, height: 36, borderRadius: "50%", border: "1.5px solid #d8d4c4", display: "grid", placeItems: "center", background: "transparent", color: "#141414" }}>
          <LogOut size={15} />
        </button>
      </div>
    </header>
  );
}
